export const EShapeActionMiscExtensions = wcardinal.ui.EShapeActionMiscExtensions;